<template>
  <div class="flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
    <!--
      Notification panel, show/hide based on alert state.
      Entering: "transform ease-out duration-300 transition"
        From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        To: "translate-y-0 opacity-100 sm:translate-x-0"
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="alert" :class="type">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <svg v-if="type === 'success'" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
              <rect width="36" height="36" rx="5.4" fill="#95D486"/>
              <path d="M24.0312 14.4004L15.9303 22.5094L13.5 20.0791" stroke="white" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <svg class="text-red-800" v-if="type === 'danger'"  xmlns="http://www.w3.org/2000/svg"  width="36" height="36" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-xl font-medium text-gray-900">
              {{ message }}
            </p>

          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button @click="() => handleRemove(fullAlert)" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <span class="sr-only">Close</span>
              <!-- Heroicon name: x -->
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: ["type", "message", "fullAlert"],
  methods: {
    handleRemove(alert) {
      this.$store.dispatch('removeAlertImmediately', alert);
    }
  }
}
</script>

<style scoped>
  .alert {
    @apply max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden;
  }
  .alert.success {
    @apply bg-alert-successBg border-2 border-alert-successOutline;
  }
  .alert.danger {
    @apply bg-red-300 border-2 border-red-500;
  }
</style>